export default "__VITE_ASSET__7335c1be__"